
export default {
  namespaced: true,
  state: {
    filters: {},
    fields: [],
    customFields: [],
    systemFields: [
      { id: 'PHONE', field_name: 'phone', enable: true, type: 'system' },
      { id: 'CREATED', field_name: 'created', enable: true, type: 'system' },
      { id: 'MEMBER', field_name: 'added by', enable: true, type: 'system' },
      { id: 'EMAIL', field_name: 'email', enable: true, type: 'system' },
      { id: 'GENDER', field_name: 'gender', enable: true, type: 'system' },
      { id: 'AGE', field_name: 'age', enable: true, type: 'system' },
      { id: 'NICKNAME', field_name: 'nickname', enable: false, type: 'system' },
      { id: 'OCCUPATION', field_name: 'occoupation', enable: false, type: 'system' },
      { id: 'MARITAL_STATUS', field_name: 'marital_status', enable: false, type: 'system' },
      { id: 'INSTAGRAM', field_name: 'instagram', enable: false, type: 'system' },
      { id: 'FACEBOOK', field_name: 'facebook', enable: false, type: 'system' },
      { id: 'TWITTER', field_name: 'twitter', enable: false, type: 'system' },
      { id: 'LINKEDIN', field_name: 'linkedin', enable: false, type: 'system' },
      { id: 'TIKTOK', field_name: 'tiktok', enable: false, type: 'system' }
    ],
    selectedCustomers: []
  },
  mutations: {
    setFilters (state, filters) {
      state.filters = filters
    },
    setFilterObject (state, data) {
      state.filters[data.key] = data.value
    },
    resetFilters (state) {
      state.filters = {}
    },
    setFields (state, fields) {
      state.fields = fields ?? []
    },
    setNewField (state, field) {
      state.fields.push(field)
    },
    setCustomFields (state, fields) {
      state.customFields = fields ?? []
    },
    setSelectedCustomers (state, customers) {
      state.selectedCustomers = customers
    },
    resetSelectedCustomers (state) {
      state.selectedDonors = []
    },
  },
  getters: {
    getFilters (state) {
      return state.filters
    },
    getFields (state) {
      return state.fields
    },
    getCustomFields (state) {
      return state.customFields
    },
    getAllFields (state) {
      const fields = [...state.systemFields, ...state.customFields]
      const savedFields = JSON.parse(localStorage.getItem('yz_customer_fields'))
      if (savedFields) {
        fields.map(field => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getSelectedCustomers (state) {
      return state.selectedCustomers
    }
  }
}